import { howItWorksFunctions } from './howItWorks'

/** Illustrative workflow: a request becomes a reviewed next step, then progress review. */
export const informationToAction = [
  { step: 'A request arrives', body: 'A resident asks for help finding a training place they can reach.' },
  { step: 'Information is checked', body: 'The team reviews what is already known and asks only for what is missing.' },
  { step: 'A team takes responsibility', body: 'The request has a clear owner and a visible next step.' },
  {
    step: 'Support is coordinated',
    body: 'The team arranges a referral, sharing the information the resident has agreed to provide.',
  },
  { step: 'The decision is recorded', body: 'The resident and the team can see the decision, its reason and what happens next.' },
  {
    step: 'Progress is reviewed',
    body: 'The team follows up to understand what helped, what barriers remain and how the service can improve.',
  },
]

/** Three connected functions for the homepage "How it works" section. */
export const homeFunctions = howItWorksFunctions

export const homeResearchPoints = [
  'Knowledge systems that keep every finding connected to its source',
  'The Human Capability Framework, CJI and NCJI’s five pillars',
  'Studies, pilots and publication plans, labeled by status',
]
